import { isLocalEnv } from 'utils';

export const dataDogInit = () => {
  if (isLocalEnv) {
    return null;
  }
  const loadDatadogScript = () => {
    (function (h, o, u, n, d) {
      h = h[d] = h[d] || {
        onReady: function (c) {
          h.q.push(c);
        },
        q: [],
      };
      d = o.createElement(u);
      d.async = 1;
      d.src = 'https://www.datadoghq-browser-agent.com/eu1/v5/datadog-rum.js';
      n = o.getElementsByTagName(u)[0];
      n.parentNode.insertBefore(d, n);
    })(
      window,
      document,
      'script',
      'https://www.datadoghq-browser-agent.com/eu1/v5/datadog-rum.js',
      'DD_RUM',
    );
  };

  const initDataDog = () => {
    const version = (SYS_CONFIG.version || '').replace(/\/[^\/]+\//, '') || 'unknown';

    loadDatadogScript();
    window.DD_RUM.onReady(function () {
      window.DD_RUM.init({
        applicationId: 'e2bb4c27-3dc9-444e-8146-806de87a1d55',
        clientToken: 'pub3ec018f4bb1dae47ea68f8d5243c7fed',
        env: SYS_CONFIG.env,
        service: 'mobile',
        sessionReplaySampleRate: 1,
        sessionSampleRate: 1,
        site: 'datadoghq.eu',
        trackLongTasks: true,
        trackResources: true,
        trackUserInteractions: true,
        version: version,
      });
    });
  };

  let isDataDogInitialized = false;

  const checkAndInitDataDog = () => {
    if (isDataDogInitialized) {
      return;
    }

    const acceptedCookies = window.localStorage.getItem('isCookiesAllowed') === 'true';
    const disabledCookies =
      window.SiteConfigManager?.config?.config?.config?.general?.enableCookiesPopup === false;
    const enabledOneButtonCookies =
      window.SiteConfigManager?.config?.config?.config?.general?.cookiesType === 'Ok';

    if (acceptedCookies || disabledCookies || enabledOneButtonCookies) {
      initDataDog();
      isDataDogInitialized = true;
    }
  };

  const initLocalStorageListener = () => {
    setInterval(() => {
      checkAndInitDataDog();
    }, 1000);
  };

  checkAndInitDataDog();
  initLocalStorageListener();
};
